import React from "react";
import { RouteComponentProps } from "react-router-dom";
import useGlobal from "../../../../store";
import { Device } from "../../../../store/extendedApiTypes";
import deviceMatchParams from "../../deviceMatchParams";
import { DeviceType } from "../../../../API";
import CustomDeviceSummary from "./customDeviceSummary";
import DefaultDeviceSummary from "./defaultDeviceSummary";
import { Typography } from "@material-ui/core";
import SEOptimizerDeviceSummary from "./seOptimizerDeviceSummary/SEOptimizerDeviceSummary";

interface IDeviceDetailsProps extends RouteComponentProps<deviceMatchParams> {}

const DeviceDetails: React.FunctionComponent<IDeviceDetailsProps> = ({ match }) => {
  const deviceId = match.params.deviceId;
  const deviceType = match.params.deviceType;

  const [{ devices }] = useGlobal();
  const device: Device | undefined = devices.find(
    (currentDevice) => currentDevice.id === deviceId && currentDevice.type === deviceType
  );

  if (!device) {
    return (
      <div>
        <Typography variant="body1" paragraph>
          No details found for device.
        </Typography>
      </div>
    );
  }

  switch (device.type) {
    case DeviceType.SEVA:
    case DeviceType.TEM:
    case DeviceType.OPENECS:
      return <CustomDeviceSummary device={device} />;
    case DeviceType.SE2OPTIMIZER:
      return <SEOptimizerDeviceSummary device={device} />;
    case DeviceType.TESTDUMMY:
      return <DefaultDeviceSummary device={device} />;
  }
};

export default DeviceDetails;
